<div id="tour-snap-header" class="flex align-items-center gap-2 mb-0">
  <h2 class="mb-0">Hosted Snapshots</h2>
  <button
    pButton
    [text]="true"
    [rounded]="true"
    icon="pi pi-question-circle"
    pTooltip="Start tour"
    tooltipPosition="bottom"
    (click)="startTour()"
  ></button>
</div>

<div id="tour-snap-toolbar" class="toolbar mb-3 mt-0">
  <p-tabMenu id="tour-snap-tabs" [model]="tabs" [(activeItem)]="activeTab" class="tabs"></p-tabMenu>

  <div class="controls">
    <p-dropdown
      [options]="domains"
      [(ngModel)]="domain"
      optionLabel="domain"
      optionValue="domain"
      [filter]="true"
      filterBy="domain,description"
      [showClear]="true"
      [virtualScroll]="true"
      [virtualScrollItemSize]="36"
      [autoDisplayFirst]="false"
      placeholder="Select domain (code or description)"
      styleClass="w-25rem"
      pTooltip="Domain"
      (onChange)="loadSnapshots()"
    >
      <ng-template pTemplate="item" let-d>
        <div class="flex flex-column">
          <span class="font-medium">{{ d.domain }}</span>
          <small class="text-600">{{ d.description }}</small>
        </div>
      </ng-template>

      <ng-template pTemplate="selectedItem" let-d>
        <div class="flex align-items-center gap-2">
          <span>{{ d?.domain }}</span>
          <small class="text-600 truncate">{{ d?.description }}</small>
        </div>
      </ng-template>
    </p-dropdown>

    <span class="text-600">limit</span>
    <input
      type="number"
      class="p-inputtext p-component w-6rem"
      [(ngModel)]="limit"
      min="1"
    />

    <p-button
      icon="pi pi-refresh"
      severity="secondary"
      [rounded]="true"
      [raised]="true"
      pTooltip="Reload"
      (onClick)="loadSnapshots()"
    />
  </div>
</div>

<!-- ==================== TAB: SNAPSHOTS (split view) ==================== -->
<div *ngIf="activeTab.id === 'list'">
  <div class="grid">
    <!-- IZQ -->
    <div class="col-12 md:col-5">
      <p-progressSpinner
        *ngIf="loadingList"
        styleClass="block mx-auto my-5"
        strokeWidth="4"
      ></p-progressSpinner>

      <div class="box">
        <!-- borde + padding -->
        <p-table
          *ngIf="!loadingList"
          [value]="snapshots"
          dataKey="id"
          selectionMode="single"
          [(selection)]="selectedSnapshot"
          (onRowSelect)="onRowSelect()"
          [paginator]="true"
          [rows]="15"
          [rowsPerPageOptions]="[10, 15, 30, 50]"
          [sortMode]="'single'"
          sortField="capturedAt"
          [sortOrder]="-1"
          responsiveLayout="scroll"
          styleClass="p-datatable-sm snapshot-list"
        >
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="id">ID <p-sortIcon field="id" /></th>
              <th pSortableColumn="capturedAt" class="captured-col">
                Captured <p-sortIcon field="capturedAt" />
              </th>
              <th pSortableColumn="rowCount" class="rows-col">
                CreatedBy
                <p-sortIcon field="rowCount" />
              </th>
              <th class="eom-col">EOM</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-s>
            <tr [pSelectableRow]="s">
              <td class="font-medium">{{ s.id }}</td>
              <td class="captured-col">
                <span
                  class="truncate"
                  [pTooltip]="toLocal(s.capturedAt)"
                  tooltipPosition="bottom"
                >
                  {{ toLocal(s.capturedAt) }}
                </span>
              </td>
              <td class="rows-col">{{ s.createdBy }}</td>
              <td class="eom-col">
                <p-tag
                  *ngIf="s.isFinalOfMonth"
                  value="EOM"
                  severity="success"
                  styleClass="eom-chip"
                  pTooltip="End of Month snapshot"
                ></p-tag>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <!-- DER -->
    <div class="col-12 md:col-7">
      <div class="box right-box">
        <!-- borde + padding + separación interna -->
        <div class="flex align-items-center justify-content-between mb-2">
          <div class="text-600 text-sm">
            <ng-container *ngIf="selectedSnapshot; else noSel">
              <b>Snapshot:</b> {{ selectedSnapshot.id }} &nbsp;|&nbsp;
              <b>Date:</b>
              {{ toLocal(selectedSnapshot.capturedAt) }} &nbsp;|&nbsp;
              <b>Description:</b> {{ rows.length > 0 ? rows[0].DESCRIPTION : '' }}
            </ng-container>
            <ng-template #noSel>
              <span>Select a snapshot to view its content.</span>
            </ng-template>
          </div>
          <div class="flex align-items-center gap-2">
            <p-button
              *ngIf="selectedSnapId"
              icon="pi pi-refresh"
              size="small"
              severity="secondary"
              [rounded]="true"
              [outlined]="true"
              pTooltip="Refresh snapshot (ignore cache)"
              (onClick)="forceRefreshSelected()"
            />
          </div>
        </div>

        <div *ngIf="summaryRows?.length" class="mb-2">
          <div *ngFor="let r of summaryRows" class="mb-1">
            <span class="font-bold">{{ r.SERVICE_TYPE }}</span>
            <span class="ml-2">{{ r.QUANTITY }}</span>
          </div>
        </div>

        <p-progressSpinner
          *ngIf="loadingRows"
          styleClass="block mx-auto my-3"
          strokeWidth="4"
        ></p-progressSpinner>

        <p-table
          *ngIf="!loadingRows && detailRows?.length"
          [value]="detailRows"
          [paginator]="true"
          [rows]="12"
          [rowsPerPageOptions]="[10, 12, 20, 50]"
          [tableStyle]="{ 'min-width': '36rem' }"
          styleClass="p-datatable-sm"
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="w-3">Site</th>
              <th class="w-3">Scope</th>
              <th class="w-3">Service type</th>
              <th class="w-3 text-right">Quantity</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-r>
            <tr>
              <td>{{ r.SITE }}</td>
              <td>{{ r.SCOPE }}</td>
              <td>{{ r.SERVICE_TYPE }}</td>
              <td class="text-right">{{ r.QUANTITY }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

<!-- ==================== TAB: COMPARE ==================== -->
<div *ngIf="activeTab.id === 'compare'">
  <!-- Loading -->
  <p-progressSpinner
    *ngIf="loadingDiff"
    styleClass="block mx-auto my-3"
    strokeWidth="4"
  ></p-progressSpinner>

  <!-- ===== Compare Bar ===== -->
  <div class="compare-bar mb-2">
    <div class="mode">
      <p-selectButton
        [options]="compareModeOptions"
        [(ngModel)]="compareMode"
        (onChange)="onCompareModeChange()"
        optionLabel="label"
        optionValue="value"
      ></p-selectButton>
    </div>

    <div class="field-inline">
      <label class="lbl text-600 text-sm">From: </label>
      <p-dropdown
        class="dd dd-compact"
        [options]="snapshotsForMode"
        [(ngModel)]="fromId"
        optionValue="id"
        [filter]="true"
        placeholder="Select…"
        appendTo="body"
      >
        <ng-template pTemplate="item" let-s>
          <div class="flex align-items-center gap-2">
            <span class="truncate"
              >{{ s.id }} — {{ toLocal(s.capturedAt) }}</span
            >
            <p-tag
              *ngIf="s.isFinalOfMonth"
              value="EOM"
              severity="success"
              styleClass="eom-chip"
            ></p-tag>
          </div>
        </ng-template>
        <ng-template pTemplate="selectedItem" let-s>
          <div class="flex align-items-center gap-2">
            <span class="truncate"
              >{{ s?.id }} — {{ toLocal(s?.capturedAt) }}</span
            >
            <p-tag
              *ngIf="s?.isFinalOfMonth"
              value="EOM"
              severity="success"
              styleClass="eom-chip"
            ></p-tag>
          </div>
        </ng-template>
      </p-dropdown>
    </div>

    <div class="field-inline">
      <label class="lbl text-600 text-sm">To: </label>
      <p-dropdown
        class="dd dd-compact"
        [options]="snapshotsForMode"
        [(ngModel)]="toId"
        optionValue="id"
        [filter]="true"
        placeholder="Select…"
        appendTo="body"
      >
        <ng-template pTemplate="item" let-s>
          <div class="flex align-items-center gap-2">
            <span class="truncate"
              >{{ s.id }} — {{ toLocal(s.capturedAt) }}</span
            >
            <p-tag
              *ngIf="s.isFinalOfMonth"
              value="EOM"
              severity="success"
              styleClass="eom-chip"
            ></p-tag>
          </div>
        </ng-template>
        <ng-template pTemplate="selectedItem" let-s>
          <div class="flex align-items-center gap-2">
            <span class="truncate"
              >{{ s?.id }} — {{ toLocal(s?.capturedAt) }}</span
            >
            <p-tag
              *ngIf="s?.isFinalOfMonth"
              value="EOM"
              severity="success"
              styleClass="eom-chip"
            ></p-tag>
          </div>
        </ng-template>
      </p-dropdown>
    </div>

    <div class="run">
      <p-button
        label="Compare"
        icon="pi pi-refresh"
        (onClick)="compare()"
        [disabled]="!fromId || !toId || loadingDiff"
      ></p-button>
    </div>
  </div>

  <p-card *ngIf="!loadingDiff && diff" styleClass="compare-card mb-3">
    <ng-template pTemplate="header">
      <div class="compare-head">
        <span class="title">Totals summary</span>
        <span class="range text-600" *ngIf="fromId && toId">
          From: {{ captureLabel(fromId) }} &nbsp;→&nbsp; To:
          {{ captureLabel(toId) }}
        </span>
      </div>
    </ng-template>

    <ul class="totals-list" *ngIf="totalsMerged.length; else noTotals">
      <li *ngFor="let t of totalsMerged">
        <span class="name">{{ t.name }}:</span>
        <span [ngClass]="t.delta > 0 ? 'delta-pos' : 'delta-neg'">
          {{ t.delta > 0 ? '+' + t.delta : t.delta }}
        </span>
      </li>
    </ul>
    <ng-template #noTotals>
      <div class="text-600 px-3 pb-2">No total changes.</div>
    </ng-template>
  </p-card>

  <div *ngIf="!loadingDiff && diff" class="grid">
    <!-- Added -->
    <div
      class="col-12 md:col-6 lg:col-4"
      *ngIf="nonTotalRows(diff.added)?.length"
    >
      <p-card styleClass="diff-card added">
        <ng-template pTemplate="header">
          <div class="diff-head">
            <span>Added</span>
            <p-badge
              [value]="nonTotalRows(diff.added).length"
              severity="success"
            ></p-badge>
          </div>
        </ng-template>

        <p-table
          [value]="nonTotalRows(diff.added)"
          [paginator]="true"
          [rows]="10"
          [rowsPerPageOptions]="[10, 20, 50]"
          styleClass="p-datatable-sm"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Site</th>
              <th>Scope</th>
              <th>Service type</th>
              <th class="text-right">Before</th>
              <th class="text-right">After</th>
              <th class="text-right">Δ</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-r>
            <tr>
              <td>{{ r.site || '—' }}</td>
              <td>{{ r.scope || '—' }}</td>
              <td>{{ r.serviceType }}</td>
              <td class="text-right text-600">{{ r.beforeQty }}</td>
              <td class="text-right">{{ r.afterQty }}</td>
              <td class="text-right delta-pos">+{{ r.delta }}</td>
            </tr>
          </ng-template>
        </p-table>
      </p-card>
    </div>

    <!-- Changed -->
    <div
      class="col-12 md:col-6 lg:col-4"
      *ngIf="nonTotalRows(diff.changed)?.length"
    >
      <p-card styleClass="diff-card changed">
        <ng-template pTemplate="header">
          <div class="diff-head">
            <span>Changed</span>
            <p-badge
              [value]="nonTotalRows(diff.changed).length"
              severity="info"
            ></p-badge>
          </div>
        </ng-template>

        <p-table
          [value]="nonTotalRows(diff.changed)"
          [paginator]="true"
          [rows]="10"
          [rowsPerPageOptions]="[10, 20, 50]"
          styleClass="p-datatable-sm"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Site</th>
              <th>Scope</th>
              <th>Service type</th>
              <th class="text-right">Before</th>
              <th class="text-right">After</th>
              <th class="text-right">Δ</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-r>
            <tr>
              <td>{{ r.site || '—' }}</td>
              <td>{{ r.scope || '—' }}</td>
              <td>{{ r.serviceType }}</td>
              <td class="text-right text-600">{{ r.beforeQty }}</td>
              <td class="text-right">{{ r.afterQty }}</td>
              <td
                class="text-right"
                [ngClass]="
                  r.delta > 0 ? 'delta-pos' : r.delta < 0 ? 'delta-neg' : ''
                "
              >
                {{ r.delta > 0 ? '+' + r.delta : r.delta }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-card>
    </div>

    <!-- Removed -->
    <div
      class="col-12 md:col-6 lg:col-4"
      *ngIf="nonTotalRows(diff.removed)?.length"
    >
      <p-card styleClass="diff-card removed">
        <ng-template pTemplate="header">
          <div class="diff-head">
            <span>Removed</span>
            <p-badge
              [value]="nonTotalRows(diff.removed).length"
              severity="danger"
            ></p-badge>
          </div>
        </ng-template>

        <p-table
          [value]="nonTotalRows(diff.removed)"
          [paginator]="true"
          [rows]="10"
          [rowsPerPageOptions]="[10, 20, 50]"
          styleClass="p-datatable-sm"
        >
          <ng-template pTemplate="header">
            <tr>
              <th>Site</th>
              <th>Scope</th>
              <th>Service type</th>
              <th class="text-right">Before</th>
              <th class="text-right">After</th>
              <th class="text-right">Δ</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-r>
            <tr>
              <td>{{ r.site || '—' }}</td>
              <td>{{ r.scope || '—' }}</td>
              <td>{{ r.serviceType }}</td>
              <td class="text-right text-600">{{ r.beforeQty }}</td>
              <td class="text-right">{{ r.afterQty }}</td>
              <td class="text-right delta-neg">{{ r.delta }}</td>
            </tr>
          </ng-template>
        </p-table>
      </p-card>
    </div>
  </div>
</div>
